export function getClipboardData({ clipboardData }: { clipboardData: DataTransfer | null }): string | undefined {
  if (!clipboardData) {
    return (window as any).clipboardData.getData('Text');
  } else {
    return clipboardData.getData('text');
  }
}
